__webpack_require__.p = "https://thunderseethe.dev/making-a-language/";